import React from 'react';

import { LogIn } from 'lucide-react';

import Table from '../../components/common/Table';

interface MemberTableProps {
  data: any[];
  handleEdit: (service: any) => void;
  handleDelete: (service: any) => void;
  handleImpersonateLogin: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
  sortBy?: string;
  sortDescending?: boolean;
  onSort?: (sortKey: string) => void;
}

const MemberTable: React.FC<MemberTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  handleImpersonateLogin,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
  sortBy,
  sortDescending,
  onSort,
}) => (
  <Table
    columns={[
      {
        label: 'Membership Number',
        key: 'membershipNumber',
        sortable: true,
        sortKey: 'MembershipNumber',
      },
      {
        label: 'First Name',
        key: 'firstName',
        sortable: true,
        sortKey: 'FirstName',
      },
      {
        label: 'Last Name',
        key: 'lastName',
        sortable: true,
        sortKey: 'LastName',
      },
      {
        label: 'Email',
        key: 'email',
        sortable: true,
        sortKey: 'Email',
      },
      {
        label: 'Phone',
        key: 'phone',
        sortable: true,
        sortKey: 'Phone',
      },
    ]}
    data={data}
    actions={{
      onEdit: handleEdit,
      onDelete: handleDelete,
      extra: [
        {
          label: 'Login as member',
          icon: <LogIn />,
          confirmMessage: 'Are you sure you want to login as this member?',
          onClick: handleImpersonateLogin,
        },
      ],
    }}
    currentPage={currentPage}
    totalPages={totalPages}
    onPageChange={setCurrentPage}
    pageSize={pageSize}
    onPageSizeChange={setPageSize}
    isLoading={isLoading}
    sortBy={sortBy}
    sortDescending={sortDescending}
    onSort={onSort}
  />
);

export default MemberTable;
